import { createSvgIcon } from '@mui/material';
import Styled from "./custom-styled-icon";

export const DollarCircle = Styled(
  createSvgIcon(
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.78125 9.55356C5.78125 10.4136 6.44125 11.1069 7.26125 11.1069H8.93458C9.64792 11.1069 10.2279 10.5002 10.2279 9.75356C10.2279 8.94022 9.87458 8.65355 9.34792 8.46689L6.66125 7.53356C6.13458 7.34689 5.78125 7.06022 5.78125 6.24689C5.78125 5.50022 6.36125 4.89355 7.07458 4.89355H8.74792C9.56792 4.89355 10.2279 5.58689 10.2279 6.44689"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 4V12"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.99992 14.6663C11.6818 14.6663 14.6666 11.6816 14.6666 7.99967C14.6666 4.31778 11.6818 1.33301 7.99992 1.33301C4.31802 1.33301 1.33325 4.31778 1.33325 7.99967C1.33325 11.6816 4.31802 14.6663 7.99992 14.6663Z"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>,
    "DollarCircle",
  ),
);

export default DollarCircle;
